/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

import $ from "jquery";
import template from "lodash/template";
import OnlineDot from "shared/components/OnlineDot.html.js";
import _str from "shared/util/_str";

const templates = {
	tags: ({ tags }) => `\
<div class="qvtags">
	${tags.map((tag, idx) => `
		<div class="qvtags-tag">
			${idx ? ', ' : ''}
			${tag}
		</div>
	`).join("")}
</div>\
`,

	interests: ({ interests }) => `\
<div class="qvinterests">
	<div class="qvinterests-label">
		<%- label %>:
	</div>
	${interests.map((interest, idx) => `
		<div class="qvinterests-interest">
			${interest}
			${idx + 1 == interests.length ? '' : ', '}
		</div>
	`).join("")}
</div>\
`,

	empty: `\
<div class="qvempty">
	${_str("Not enough info. Drats!")}
</div>\
`,
};

window.ProfileQuickview = {
	linkSelector: "[data-profile-popover]",
	loadDelay: 150,
	openDelay: 400,
	closeDelay: 300,
	minSpacing: 55,
	arrowDistance: 70,

	init(params) {
		// Bind params to object
		$.extend(this, params);

		this.data = {
			user: null,
			loading: false,
			screenname: params.screenname,
			theirscreenname: params.theirscreenname,
		};

		this.cache = {
			users: {},
		};

		let popover = $(".quickview");

		this.dom = {
			popover,
			popoverArrow: popover.children(".quickview-arrow"),
			userPhoto: popover.find("img"),
			userOnline: popover.find(".quickview-top-photo-online"),
			userName: popover.find(".quickview-top-username"),
			userAge: popover.find(".quickview-top-demo-age"),
			userLocation: popover.find(".quickview-top-demo-location"),
			userPercentage: popover.find(".quickview-top-percentage"),
			userContent: popover.find(".quickview-bottom"),
			pinBtn: popover.find(".pin"),
		};

		this.loader = new OkLoader(this.dom.popover, {
			size: "xsmall",
			fade: 0,
		});

		this.templates = {};

		for (let key in templates) {
			let thisTemplate = templates[key];
			this.templates[key] = (params) => template(thisTemplate(params).replace(/[\n\r\t]/g, ""));
		}

		return this.listen();
	},

	listen() {
		// Popover open handling
		$(document).on("mouseenter", this.linkSelector, ev => {
			// Back out if we're clicking on our profile, or theirs while on it.
			let username = this.getUsernameFromElement(ev.currentTarget);

			if (!this.isValidUsername(username)) {
				return;
			}

			this.close();

			clearTimeout(this.closeTimeout);
			this.dom.activeTriggeringElement = $(ev.currentTarget);

			this.loadTimeout = setTimeout(() => {
				this.loadProfile(username);
			}, this.loadDelay);

			this.openTimeout = setTimeout(() => {
				this.open();
			}, this.openDelay);
		});

		// Popover close handling
		$(document).on("mouseleave", this.linkSelector, ev => {
			if (this.data.inPopover) {
				return;
			}

			clearTimeout(this.loadTimeout);
			clearTimeout(this.openTimeout);

			this.closeTimeout = setTimeout(() => {
				this.close();
			}, this.closeDelay);
		});

		this.dom.popover.on("mouseenter", () => {
			clearTimeout(this.closeTimeout);
			this.data.inPopover = true;
		});

		this.dom.popover.on("mouseleave", () => {
			this.close();
		});

		// Reposition on scroll, focus, resize
		$(window).on("scroll resize focus", ev => {
			if (!this.data.open || !this.dom.activeTriggeringElement.length) {
				return;
			}

			this.positionOnTarget(this.dom.activeTriggeringElement);
		});

		// Admin jank
		this.dom.pinBtn.on("click tap", () => {
			this.pinned = !this.pinned;
		});
	},

	render() {
		// User loaded
		if (this.data.user) {
			// User info
			let url = `/profile/${this.data.user.username}`;

			if (this.data.cf) {
				url += `?cf=${this.data.cf}`;
			}

			this.dom.userName.attr("href", url);
			this.dom.userPhoto.parent().attr("href", url);
			this.dom.userName.html(this.data.user.userinfo.displayname);

			if (this.data.user.online) {
				this.dom.userName.append(OnlineDot);
			}

			this.dom.userAge.html(this.data.user.userinfo.age);
			this.dom.userLocation.html(this.data.user.userinfo.location);
			this.dom.userPhoto.attr("src", this.data.user.thumbs[0]["82x82"]);
			this.dom.userOnline.toggleClass("isOnline", !!this.data.user.online);

			if (
				(this.data.user.percentages != null
					? this.data.user.percentages.match
					: undefined) != null
			) {
				this.dom.userPercentage.html(`${this.data.user.percentages.match}<span>%</span>`);
			} else {
				this.dom.userPercentage.html("");
			}

			/* Content */
			let content = [];

			// Detail tags
			if (
				this.data.user.detail_tags != null
					? this.data.user.detail_tags.length
					: undefined
			) {
				content.push(
					this.templates.tags({
						tags: this.data.user.detail_tags,
					})
				);
			}

			// Interests
			if (
				this.data.user.interests != null
					? this.data.user.interests.length
					: undefined
			) {
				let interests = [];
				let label = "My interests";

				if (this.interestsType === "similar") {
					label = "You’re both into";
				}

				for (let interest of this.data.user.interests) {
					if (this.interestsType === "similar") {
						if (!interest.similar && !interest.shared) {
							continue;
						}
					}

					interests.push(interest.name);
				}

				if (interests.length) {
					interests = interests.slice(0, 5);
					content.push(
						this.templates.interests({
							label,
							interests,
						})
					);
				}
			}

			if (content.length) {
				this.dom.userContent.html(content);
			} else {
				this.dom.userContent.html(this.templates.empty());
			}
			// No user loaded
		} else {
			this.dom.userName.html("");
			this.dom.userAge.html("");
			this.dom.userLocation.html("");
			this.dom.userPercentage.html("");
			this.dom.userPhoto.attr("src", "");
		}

		// Close and back out if we're closed
		if (!this.data.open) {
			this.dom.popover.removeClass("show");
			return;
		}

		// Start the loader
		if (this.data.loading || !this.data.user) {
			this.dom.popover.addClass("loading");
			this.loader.start();
		} else {
			this.dom.popover.removeClass("loading");
			this.loader.stop();
		}

		// Show the popover once all that's figured out
		this.dom.popover.addClass("show");

		if (
			this.dom.activeTriggeringElement != null
				? this.dom.activeTriggeringElement.length
				: undefined
		) {
			this.positionOnTarget(this.dom.activeTriggeringElement);
		}
	},

	organizePesonalityTraits(traits) {
		// Make a deep copy so we don't mess with the original traits
		traits = JSON.parse(JSON.stringify(traits));

		// Grab most positive as first
		let topTrait = traits.shift();

		// Then reorganize by extremes
		traits = traits.sort(
			(a, b) => Math.abs(b.percentile - 50) - Math.abs(a.percentile - 50)
		);

		traits.unshift(topTrait);

		return traits.slice(0, 3);
	},

	open() {
		if (
			!(this.dom.activeTriggeringElement != null
				? this.dom.activeTriggeringElement.length
				: undefined)
		) {
			return;
		}

		this.data.open = true;
		this.handleCf(this.dom.activeTriggeringElement);

		return this.render();
	},

	close() {
		if (this.pinned) {
			return;
		}

		this.data.user = null;
		this.data.open = false;
		this.data.inPopover = false;

		return this.render();
	},

	positionOnTarget($target) {
		let wWidth = $(window).width();
		let wHeight = $(window).height();
		let scrollTop = $(window).scrollTop();
		let tOffset = $target.offset();
		let tBox = $target.get(0).getBoundingClientRect();
		let pBox = this.dom.popover.get(0).getBoundingClientRect();
		let flipped = false;
		let top = 0;
		let left = 0;
		let aMarginLeft = 0;

		// Top and overflow handling
		top = tOffset.top - pBox.height - 18;
		if (top < this.minSpacing + scrollTop) {
			flipped = true;
			top = tOffset.top + tBox.height + 18;
		}

		// Left / right handling
		left = tBox.left - this.arrowDistance + tBox.width / 2;
		aMarginLeft = -(pBox.width / 2) + this.arrowDistance;
		if (left + pBox.width > wWidth - this.minSpacing) {
			left = tBox.left - pBox.width + this.arrowDistance + tBox.width / 2;
			aMarginLeft *= -1;
		}

		// Apply styles
		this.dom.popover.toggleClass("flipped", flipped);
		this.dom.popover.css({
			top,
			left,
		});

		this.dom.popoverArrow.css("margin-left", aMarginLeft);
	},

	loadProfile(username) {
		// Short circuit if we've cached their data
		if (this.cache.users[username]) {
			this.data.user = this.cache.users[username];
			this.render();
			return;
		}

		this.data.loading = true;
		this.render();

		let fields = ["thumbs.limit(1)", "userinfo", "percentages", "online"];
		if (this.interestsType) {
			fields.push("interests.limit(5)");
		} else {
			fields.push("detail_tags");
		}

		__guardMethod__(this.activeXhr, "abort", o => o.abort());

		this.activeXhr = OkC.api(
			`/profile/${username}/fields`,
			{
				api: 1,

				data: {
					fields: fields.join(","),
					action: "quickview",
				},

				success: response => {
					this.cache.users[username] = response;
					this.data.user = response;
					return this.render();
				},

				error: () => {
					return (this.data.user = null);
				},

				complete: () => {
					this.activeXhr = null;
					this.data.loading = false;
					return this.render();
				},
			},
		);
	},

	getUsernameFromElement(el) {
		if ((el != null ? el.pathname : undefined) != null) {
			return __guard__(
				el != null ? el.pathname : undefined,
				x => x.split(/[\/\?]/)[2]
			);
		} else {
			return String($(el).data("username"));
		}
	},

	// Set CFs on target element, and save it for popover links
	handleCf(el) {
		// Convert from jqurty object, back out if not a link
		if (el.length) {
			el = el.get(0);
		}

		if (!el.href) {
			return;
		}

		if (el.href.indexOf("profile_quickview") !== -1) {
			return;
		}

		let newPath = el.pathname + el.search + el.hash;

		// Figure out what CFs we need
		if ((el.search != null ? el.search.indexOf("cf") : undefined) !== -1) {
			this.data.cf = UrlHelpers.getParam("cf", newPath) + ",profile_quickview";
		} else {
			this.data.cf = "profile_quickview";
		}

		// Create the full path
		if (!el.search) {
			newPath += `?cf=${this.data.cf}`;
		} else if (el.search.indexOf("cf") !== -1) {
			newPath = newPath.replace(/cf=[^&#]+/, `cf=${this.data.cf}`);
		} else {
			newPath += `&cf=${this.data.cf}`;
		}

		$(el).parent().find("a").each(function(idx, linkEl) {
			if (linkEl.pathname !== el.pathname) {
				return;
			}

			linkEl.href = newPath;
		});
	},

	isValidUsername(username) {
		if (!username) {
			return false;
		}

		let ucUname = username != null ? username.toUpperCase() : undefined;

		if (
			ucUname ===
			(this.data.screenname != null
				? this.data.screenname.toUpperCase()
				: undefined)
		) {
			return false;
		}

		// Used to not open load on their profile, might do this again later.
		//if ucUname == @data.theirscreenname?.toUpperCase()
		//	return false
		return true;
	},

	fireStat(stat) {
		ClientStats.update({ statname: `profile quickview - ${stat}` });
	},
};

function __guardMethod__(obj, methodName, transform) {
	if (
		typeof obj !== "undefined" &&
		obj !== null &&
		typeof obj[methodName] === "function"
	) {
		return transform(obj, methodName);
	} else {
		return undefined;
	}
}
function __guard__(value, transform) {
	return typeof value !== "undefined" && value !== null
		? transform(value)
		: undefined;
}



// WEBPACK FOOTER //
// ./src/legacy/profile_quickview.js